import React, { Component } from 'react';
import {Provider} from 'react-redux';
import 'antd/dist/antd.css'; 
import './App.css';
import { BrowserRouter as Router, Switch, Redirect, Route, withRouter } from 'react-router-dom';
import store, {CART_COUNT_UPDATE} from './utils/store';

import Home from './components/Home';
import Signin from './components/Signin';
import Products from './components/Products';
import Details from './components/Details';
import Aboutus from './components/pages/Aboutus';
import Deliveryinfo from './components/pages/Deliveryinfo';
import Privacypolicy from './components/pages/Privacypolicy';
import Refundpolicy from './components/pages/Refundpolicy';
import Terms from './components/pages/Terms';

import Contactus from './components/pages/Contactus';
import Brands from './components/Brands';
import Geforcertxpc from './components/Geforcertxpc';
import Compare from './components/Compare';

import Account from './components/account/Account';
import Address from './components/account/Address';
import ChangePassword from './components/account/ChangePassword';
import Wishlist from './components/account/Wishlist';
import Cart from './components/account/Cart';
import Checkout from './components/account/Checkout';
import Reviews from './components/account/Reviews';
import Orders from './components/account/Orders';
import OrderConfirmation from './components/account/OrderConfirmation';
import OrdersTrack from './components/account/OrdersTrack';


import PrivateRoute from './components/route/PrivateRoute';
import PublicRoute from './components/route/PublicRoute';

import AuthorizedLayout from './components/layouts/authorized-layout';
import UnauthorizedLayout from './components/layouts/unauthorized-layout';

import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import Tree from './components/utils/Tree';

class App extends Component {


  constructor(props) {
      super(props);
      this.state = {
      }   
  }

  ScrollToTop = withRouter(({ location }) => {
    React.useEffect(() => {
      window.scrollTo(0, 0);
    }, [location.pathname, location.search, location.hash]);

    return null;
  });

  render() { 
    return (
      <div className="byosMainBox">
        <Provider store={store}>
          <Router>
                <this.ScrollToTop />
                <Switch>

                        <PublicRoute component={Home} path="/" exact />
                        <PublicRoute restricted={false} component={Products} path="/products/:type/:id/:name" exact />
                        <PublicRoute restricted={false} component={Details} path="/details/:id/:name" exact />
                        <PublicRoute restricted={false} component={Aboutus} path="/aboutus" exact />
                        <PublicRoute restricted={false} component={Deliveryinfo} path="/deliveryinfo" exact />
                        <PublicRoute restricted={false} component={Privacypolicy} path="/privacypolicy" exact />
                        <PublicRoute restricted={false} component={Refundpolicy} path="/refundpolicy" exact />
                        <PublicRoute restricted={false} component={Terms} path="/terms" exact />

                        <PublicRoute restricted={false} component={Contactus} path="/contactus" exact />
                        <PublicRoute restricted={false} component={Brands} path="/brands" exact />
                        <PublicRoute restricted={false} component={Geforcertxpc} path="/geforce-rtx-pcs" exact />
                        <PublicRoute restricted={false} component={Compare} path="/compare" exact />
                        <PublicRoute component={Signin} path="/signin" exact />

                        <PrivateRoute exact component={Cart} path="/cart" />
                        <PrivateRoute exact component={Checkout} path="/checkout" />
                        <PrivateRoute exact component={OrderConfirmation} path="/orderpreview" />
                        

                        <PrivateRoute exact component={Account} path="/account" />
                        <PrivateRoute exact component={Address} path="/address" />
                        <PrivateRoute exact component={ChangePassword} path="/password" />
                        <PrivateRoute exact component={Wishlist} path="/wishlist" />
                        <PrivateRoute exact component={Reviews} path="/reviews" />
                        <PrivateRoute exact component={Orders} path="/orders" />
                        <PrivateRoute exact component={OrdersTrack} path="/trackorders" />

                    {/* <Route exact path="/" component={Home}/>
                    <Route exact path="/signin" component={Signin}/> */}
                    {/* <PrivateRoute path="/profile" component={AuthorizedLayout} /> */}
                    {/* <Redirect to="/signin" /> */}
                    
                </Switch>
                <Tree />
                <a
                  className="ps-whatsapp-chat"
                  href="https://wa.me/918946025885?text=Hello%20Nature%20Way%2C%20I%20would%20like%20to%20know%20more%20about%20your%20products%20and%20offers."
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat with Nature Way on WhatsApp"
                  title="Chat with us on WhatsApp"
                >
                  <i className="fa fa-whatsapp" aria-hidden="true"></i>
                </a>
          </Router>
          </Provider>
      </div>
    );
  }
}

export default App;
